import { render, staticRenderFns } from "./SummaryChip.vue?vue&type=template&id=682af66f&"
import script from "./SummaryChip.vue?vue&type=script&lang=js&"
export * from "./SummaryChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports